import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import ISite from '../../../../../_interfaces/ISite';
import { CustomersService } from '../../../../../_services/customers/customers.service';
import { DataService } from '../../../../../_services/data/data.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { FilesService } from '../../../../../_services/files/files.service';
import { BaseComponent } from '../../../../../components/base/base.component';
import { SessionService } from '../../../../../_services/session/session.service';
import { MultiSelectModule } from 'primeng/multiselect';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { ButtonModule } from 'primeng/button';
import { AdminFormActionsComponent } from '../../../../../components/admin-ui/admin-form-actions/admin-form-actions.component';

@Component({
  standalone: true,
  selector: 'app-export-appointments',
  templateUrl: './export-appointments.component.html',
  styleUrls: ['./export-appointments.component.scss'],
  imports: [
    TranslatePipe,

    MultiSelectModule,
    FormsModule,
    DatePickerModule,
    ButtonModule,
    AdminFormActionsComponent,
  ],
})
export class ExportAppointmentsComponent extends BaseComponent {
  sites: ISite[] = [];
  selectedSites: ISite[] = [];
  startDate: Date;
  endDate: Date;
  locale: string;
  exporting = false;

  constructor(
    private customerService: CustomersService,
    private dataService: DataService,
    private messageService: MessageService,
    public session: SessionService,
    private translate: TranslateService,
    private filesService: FilesService
  ) {
    super(session);
  }

  private getSites() {
    if (!this.customer?.id) {
      this.sites = [];
      return;
    }

    this.customerService
      .getSites(this.customer.id)
      .subscribe((sites: ISite[]) => {
        this.sites = sites;
      });
  }

  exportData() {
    if (
      this.exporting ||
      !this.customer?.id ||
      !this.selectedSites?.length ||
      !this.startDate ||
      !this.endDate
    ) {
      return;
    }

    this.exporting = true;
    const exportedSites = this.selectedSites.map((x) => x.id);
    this.dataService
      .exportDataAppointments(this.customer.id, {
        sites: exportedSites,
        startDate: this.startDate,
        endDate: this.endDate,
      })
      .subscribe({
        next: (data: any) => {
          const toLocalTimeData = data.map(this.toLocalTime);
          this.generateExcel(toLocalTimeData);
          this.exporting = false;
        },
        error: () => {
          this.messageService.add({
            summary: this.translate.instant('MESSAGES.DATA.ERROR.EXPORT.SUMMARY'),
            detail: this.translate.instant('MESSAGES.DATA.ERROR.EXPORT.DETAIL'),
            severity: 'error',
          });
          this.exporting = false;
        },
      });
  }

  private toLocalTime(item): any {
    const appointment_date = moment(
      `${item['Date']}T${item['Hour']}:00+0000`
    ).local();

    item['Date'] = appointment_date.format('YYYY-MM-DD');
    item['Hour'] = appointment_date.format('HH:mm');
    if (item['Payment Date'] && item['Payment Hour']) {
      const payment_date = moment(
        `${item['Payment Date']}T${item['Payment Hour']}:00+0000`
      ).local();
      item['Payment Date'] = payment_date.format('YYYY-MM-DD');
      delete item['Payment Hour'];
    }
    return item;
  }

  private generateExcel(data: any) {
    const sites_string = this.selectedSites
      .map((x) => x.identifier)
      .reduce((a, b) => `${a}-${b}`);
    const filename = `${this.customer.name}_${sites_string}_${moment(
      this.startDate
    ).format('YYYY-MM-DD')}_${moment(this.endDate).format('YYYY-MM-DD')}`;

    this.filesService.generateExcel(filename, data);
  }

  ngOnInit() {
    super.ngOnInit();
    this.locale = this.translate.currentLang;
    this.initDate();
    this.getSites();
  }

  setMode__yesterday() {
    this.startDate = moment().startOf('day').subtract(1, 'day').toDate();
    this.endDate = moment().startOf('day').toDate();
  }
  setMode__this_week() {
    this.startDate = moment().startOf('week').toDate();
    this.endDate = moment().startOf('week').add(1, 'week').toDate();
  }

  setMode__last_week() {
    this.startDate = moment().startOf('week').subtract(1, 'week').toDate();
    this.endDate = moment().startOf('week').toDate();
  }
  setMode__this_month() {
    this.startDate = moment().startOf('month').toDate();
    this.endDate = moment().startOf('month').add(1, 'month').toDate();
  }
  setMode__last_month() {
    this.startDate = moment().startOf('month').subtract(1, 'month').toDate();
    this.endDate = moment().startOf('month').toDate();
  }
  setMode__this_year() {
    this.startDate = moment().startOf('year').toDate();
    this.endDate = moment().startOf('year').add(1, 'year').toDate();
  }
  setMode__last_year() {
    this.startDate = moment().startOf('year').subtract(1, 'year').toDate();
    this.endDate = moment().startOf('year').toDate();
  }

  initDate() {
    this.startDate = moment().startOf('month').toDate();
    this.endDate = moment().add(1, 'month').startOf('month').toDate();
  }
}
